// DeleteConfirmPopup.jsx
import React from 'react';
import Classes from './DeleteConfirmPopup.module.css';
import { useSelector } from 'react-redux';
import { motion } from 'framer-motion';

export default function DeleteConfirmPopup({
  handleClose,
  handleSubmit,
  title = 'Are you sure you want to delete?',
  description = "This action can’t be undone.",
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  confirmTone = 'danger', // 'danger' | 'primary'
  loading = false,
}) {
  // Safely read company color if your store has it; fallback to theme color
  const color =  '#d53535';

  const handleBgClick = () => {
    // click outside to close (optional: keep disabled if you want forced choice)
    // handleClose();
  };

  const handleCardClick = (event) => {
    event.stopPropagation();
  };

  const confirmStyles =
    confirmTone === 'danger'
      ? { background: color, border: `1px solid ${color}` }
      : { background: '#1f74f2', border: '1px solid #1f74f2' };

  const confirmTextColor = '#fff';

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
      className={Classes.popup}
      onClick={handleBgClick}
    >
      <motion.div
        initial={{ y: -7 }}
        animate={{ y: 0 }}
        exit={{ y: 7 }}
        transition={{ duration: 0.25 }}
        className={Classes.card}
        onClick={handleCardClick}
      >
        <div className={Classes.close} onClick={handleClose}>
          <svg xmlns="http://www.w3.org/2000/svg" height="25px" fill="white" viewBox="0 0 384 512">
            <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5 12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
          </svg>
        </div>

        <div className={Classes.bgPopup} style={{ background: color }}>
          <div></div>
          <svg xmlns="http://www.w3.org/2000/svg" height="40px" fill="white" viewBox="0 0 512 512">
            <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" />
          </svg>
          <div className={Classes.curveCon}></div>
        </div>

        <div className={Classes.cardCon}>
          <h5 className={Classes.title2}>{title}</h5>
          <div className={Classes.placeholder}>{description}</div>

          <div className={Classes.flexAlign} style={{ marginTop: '2rem' }}>
            <button
              type="button"
              onClick={handleClose}
              className={Classes.btn1}
              style={{ border: `1px solid ${color}` }}
              disabled={loading}
            >
              <h5 style={{ color }}>{cancelLabel}</h5>
            </button>

            <button
              type="button"
              onClick={handleSubmit}
              className={Classes.btn2}
              disabled={loading}
            >
              <h5 style={{ color: confirmTextColor }}>
                {loading ? 'Please wait…' : confirmLabel}
              </h5>
            </button>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}
